import { render, staticRenderFns } from "./WrapMaterialDetails.vue?vue&type=template&id=2f54107c&scoped=true&lang=html&"
import script from "./WrapMaterialDetails.vue?vue&type=script&lang=js&"
export * from "./WrapMaterialDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f54107c",
  null
  
)

export default component.exports